export enum EnumPath {
  LOGIN = "/login",
  NEW_ACCOUNT = "/new-account",
  RECOVER = "/new-password",
  EXPIRED_PASSWORD = "/reset-expired-password",
  EXPIRED_PASSWORD_MESSAGE = "/expired-password-message",
  HOME = "/home",
  CONSORTIUM = "/consortium",
  CONSORTIUM_SALES = "/consortium/sales",
  CONSORTIUM_SALES_SALES_TABLE = "/consortium/sales/sales-table",
  CONSORTIUM_SALES_PANEL = "/consortium/sales/panel",
  CONSORTIUM_REPORTS = "/consortium/reports",
  CONSORTIUM_REPORTS_BIRTHDATE = "/consortium/reports/birthdate",
  CONSORTIUM_REPORTS_PORTFOLIO_MANAGEMENT = "/consortium/reports/portfolio-management",
  CONSORTIUM_CREDIT_ANALISYS = "/consortium/credit-analisys",
  CONSORTIUM_CREDIT_ANALISYS_CONTEMPLATION_PAYMENT = "/consortium/credit-analisys/contemplation-payment",
  CONSORTIUM_RELATIONSHIP_PANEL = "/consortium/relationship-panel",
  BANK_RELATIONSHIP_PANEL = "/bank/relationship-panel",
  BANK_BAD_DEBT = "/bank/bad-debt",
  BANK_BAD_DEBT_READ = "/bank/bad-debt",
  DEALERS_DEBT_SETTLEMENT = "/bank/bad-debt/debt-settlement",
  INSURANCE_RELATIONSHIP_PANEL = "/insurance/relationship-panel",

  CONSORTIUM_REPORTS_COMMISSIONS = "/consortium/reports/commissions",

  REPORTS = "/reports",
  REPORTS_RECEIVABLES_RECONCILIATION = "/reports/receivables-reconciliation",


  SETTINGS = "/settings",
  SETTINGS_MESSAGES = "/settings/messages",
  SETTINGS_MESSAGES_CREATE = "/settings/messages/create",
  SETTINGS_MESSAGES_UPDATE = "/settings/messages/update",
  SETTINGS_MESSAGES_FILTER = "/settings/messages/search",
  SETTINGS_BANNERS = "/settings/banners",
  SETTINGS_BANNERS_FILTER = "/settings/banners/search",

  SETTINGS_BANNERS_CREATE = "/settings/banners/create",
  SETTINGS_BANNERS_UPDATE = "/settings/banners/update",
  SETTINGS_USERS = "/settings/users",
  SETTINGS_USERS_FILTER = "/settings/users/search",
  SETTINGS_USERS_CREATE = "/settings/users/create",
  SETTINGS_USERS_UPDATE = "/settings/users/update",
  SETTINGS_PROFILE = "/settings/profile",
  SETTINGS_PROFILE_CREATE = "/settings/profile/create",
  SETTINGS_PROFILE_UPDATE = "/settings/profile/update",
  SETTINGS_PROFILE_FILTER = "/settings/profile/search",
  SETTINGS_PARAMETER = "/settings/parameters",
  SETTINGS_PARAMETER_UPDATE = "/settings/parameters/update",
  SETTINGS_PARAMETER_FILTER = "/settings/parameters/search",
  SETTINGS_CONSUMPTION_REPORT = "/settings/consumption-report",
  SETTINGS_CONSUMPTION_REPORT_FILTER = "/settings/consumption-report/search",
  SETTINGS_AWARD_PROGRAM = "/settings/award-program",
  SETTINGS_AWARD_PROGRAM_FILTER = "/settings/award-program/search",
  SETTINGS_AWARD_PROGRAM_CREATE = "/settings/award-program/create",
  SETTINGS_AWARD_PROGRAM_UPDATE = "/settings/award-program/update",
  SETTINGS_AWARD_PROGRAM_LOGS_IMPORT = "/settings/award-program/import-event-logs",


  SETTINGS_DEALERS = "/settings/dealers",
  SETTINGS_DEALERS_CREATE = "/settings/dealers/create",
  SETTINGS_DEALERS_UPDATE = "/settings/dealers/update",
  SETTINGS_DEALERS_FILTER = "/settings/dealers/search",

  ECONOMICGROUPS = "/settings/economic-groups",
  ECONOMICGROUPS_CREATE = "/settings/economic-groups/create",
  ECONOMICGROUPS_UPDATE = "/settings/economic-groups/update",
  ECONOMICGROUPS_FILTER = "/settings/economic-groups/search",

  FOOTER_PRIVACY_ADVERTISING = "https://www.yamahaservicosfinanceiros.com.br/aviso-de-privacidade",
  FOOTER_CYBERSECURITY_POLICY = "https://www.yamahaservicosfinanceiros.com.br/politica-de-seguranca-cibernetica",
  FOOTER_QUALITY_ENVIRONMENT = " https://www.yamahaservicosfinanceiros.com.br/gestao-de-qualidade-ambiental",
  FOOTER_REPORTING_CHANNEL = "https://www.yamaha-motor.com.br/canaldedenuncia",
  FOOTER_CODE_ETHICS = "https://www.yamahaservicosfinanceiros.com.br/codigo-de-etica",
  FOOTER_FACEBOOK = "https://www.facebook.com/ConsorcioNacionalYamaha",
  FOOTER_YAMAHA_MOTOR = "https://www.yamaha-motor.com.br/",
  FOOTER_YAMAHA_MUSICAL = "https://br.yamaha.com/index.html",
  FOOTER_YAMAHA_NAUTICA = "https://www.yamaha-nautica.com.br",
  HOME_LEARN_MORE = "https://yamahaservicosfinanceiros.com.br/",
  DEALERS = "/Bad debt",
  BANK = "/bank",
  INSURANCE = "/insurance",
}
